export default "__VITE_ASSET__ffc28ffd__"